import Image from '@stone/ui/image/Image';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import SwiperCore, { Navigation, A11y, Keyboard, Autoplay, FreeMode, Pagination, Grid } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/grid';
import CarouselNavigation from '@stone/ui/button/CarouselNavigation';
SwiperCore.use([Keyboard, Navigation, A11y, Autoplay, FreeMode, Pagination, Grid]);
const EditorialGridImages = (props) => {
    const { IS_IMAGES, IS_VIDEO, IS_TOP, IS_VERTICAL, IS_HORIZONTAL, IS_BOTTOM, IS_OFFSET, IS_RIGHT_CONTENT_POSITION, IS_IMAGES_POSITIONED, IS_CONTENT_POSITIONED, IS_CAROUSEL, IS_GRID, IS_RIGHT, } = props.checks;
    const { images } = props;
    const hasLabel = useMemo(() => images.some((img) => !!(img === null || img === void 0 ? void 0 : img.label)), [images]);
    const classes = useMemo(() => {
        return {
            grid: classNames({ vertical: IS_VERTICAL && (images === null || images === void 0 ? void 0 : images.length) === 2 }, { double: (images === null || images === void 0 ? void 0 : images.length) === 2 }, { single: (images === null || images === void 0 ? void 0 : images.length) === 1 }, { labelled: hasLabel }),
            general: classNames({ offset: IS_OFFSET }, { right: IS_RIGHT }, { grid: IS_GRID }, { top: IS_TOP }, { bottom: IS_BOTTOM }),
        };
    }, [props.checks]);
    const swiperProps = {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.editorial-grid-navigation--next',
            prevEl: '.editorial-grid-navigation--prev',
        },
    };
    const renderImage = (image) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(Image, { src: image.image.path, srcMobile: (_a = image === null || image === void 0 ? void 0 : image.imageMobile) === null || _a === void 0 ? void 0 : _a.path, alt: image === null || image === void 0 ? void 0 : image.imgAlt }),
            (image === null || image === void 0 ? void 0 : image.label) && React.createElement("span", { className: "editorial-images-grid-image__label font__title" }, image === null || image === void 0 ? void 0 : image.label)));
    };
    const renderGrid = () => (React.createElement("ul", { className: `editorial-images-grid ${classes.grid} ${classes.general}` }, (images === null || images === void 0 ? void 0 : images.length) &&
        images.map((el) => (React.createElement("li", { className: "editorial-images-grid-image", key: el.ID }, renderImage(el))))));
    const renderCarousel = () => (React.createElement("div", { className: `editorial-images-carousel ${classes.general}` },
        React.createElement(CarouselNavigation, { id: "editorial-grid", right: true }),
        React.createElement(Swiper, Object.assign({}, swiperProps, { spaceBetween: IS_GRID ? (hasLabel ? 31 : 40) : 12, grid: {
                rows: IS_GRID ? 2 : 1,
                fill: 'row',
            } }), images === null || images === void 0 ? void 0 : images.map((el) => (React.createElement(SwiperSlide, { key: `slide-${el.ID}` }, renderImage(el)))))));
    return IS_CAROUSEL ? renderCarousel() : renderGrid();
};
export default EditorialGridImages;
